import React from "react";
import Texts from "../../../utils/lang-utils";
import { redirectTo } from "../../../utils/window-utils";
import "../assets/scss/OnboardedModal.css";

const ErrorModal = (props) => {
  return (
    <div className="onboarded-modal">
      <div className="modal-container">
        <div className="onboarded-modal-icon-error">
          <i className="fa fa-times"></i>
        </div>
        <div className="onboarded-modal-text">
          <h2>{Texts.onboarding.Ops}</h2>
          <h3>{Texts.onboarding.GoesWrong}</h3>
        </div>
        <button className="onboarded-modal-btn" onClick={() => redirectTo(`/start`)}>
          {Texts.onboarding.TryAgain}
        </button>
        </div>
    </div>
  );
};

export default ErrorModal;
